export var CAR_CONDITION;
(function (CAR_CONDITION) {
  CAR_CONDITION["FAIR"] = "Fair";
  CAR_CONDITION["GOOD"] = "Good";
  CAR_CONDITION["EXCELLENT"] = "Excellent";
})(CAR_CONDITION || (CAR_CONDITION = {}));